import { useEffect } from 'react';

import { TDispatch } from '~/src/features/center/BlockInfo';

/**
 * Кастомный хук useEffect - при размонтировании компонента сбрасывает флаг active
 *
 * @function
 * @name hooks.useEffectActive
 * @returns {void}
 */
export function useEffectActive(setActive: TDispatch | undefined): void {
    return useEffect(() => {
        return () => {
            if (setActive) {
                setActive(false);
            }
        };
    }, [setActive]);
}

